import { Layouts, PolicyType } from "../../constants/Constants";
import { Urls } from "../../constants/UrlConstants";
import { SET_EXIT_SURVEY_URL } from "./loggedOutActions";

const initialState = {
  exitSurveyUrl: Urls.exitSurvey.MOL,
  exitSurveyType: Layouts.MOL
};

export default function loggedOutReducer(state = initialState, action) {
  let newState = Object.assign({}, state);

  if (action.type === SET_EXIT_SURVEY_URL) {
    if (action.payload === Layouts.HOL) {
      newState.exitSurveyUrl = Urls.exitSurvey.HOL;
    } else if (action.payload === PolicyType.International) {
      newState.exitSurveyUrl = Urls.exitSurvey.international;
    } else {
      newState.exitSurveyUrl = Urls.exitSurvey.MOL;
    }
    newState.exitSurveyType = action.payload;
  }
  return newState;
}
